import { BaseService } from '../base/base.service';
import { AppService } from '../main/app.service';

export class INote {
    id: string;
    tags: string[];
    endDate: any;
    accountName?: string;
    employeeDisplayName?: string;
    applicantName?: string;
    applicantId?: string;
}

export class NotesService extends BaseService<INote> {
    constructor(Restangular: Restangular.IService, protected AppService: AppService) {
        "ngInject";
        super(Restangular, AppService, 'crm/notes');
    }
}


// WEBPACK FOOTER //
// ./src/app/services/notes.service.ts